import { A } from 'hookrouter'
import { Button, Col, Form, Row } from 'react-bootstrap'
import React from 'react'

import { ErrorsDisplay } from 'components/ErrorsDisplay'
import { logIn } from 'state/async_actions'
import { LOGIN_ROUTES } from '../LoginRouter'
import { NoticesDisplay } from 'components/NoticesDisplay'
import { styles } from './styles'
import { useAppContext } from 'state/context'
import { useForm } from 'hooks/useForm'

export type LoginInputs = { email: string; password: string }

export const Login = () => {
  const [, dispatch] = useAppContext()
  const [inputs, handleInputChange, handleSubmit, validated] = useForm<
    LoginInputs
  >(({ email, password }) => logIn(dispatch, email, password))

  return (
    <>
      <Row>
        <Col>
          <h1>Login</h1>
          <ErrorsDisplay />
          <NoticesDisplay />
        </Col>
      </Row>
      <Row>
        <Col>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                required
                onChange={handleInputChange as any}
                value={inputs.email || ''}
                name="email"
                type="email"
                placeholder="Enter email"
              />
              <Form.Control.Feedback type="invalid">
                Please enter a valid email address.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                required
                onChange={handleInputChange as any}
                value={inputs.password || ''}
                name="password"
                type="password"
                placeholder="Password"
              />
              <Form.Control.Feedback type="invalid">
                Please enter your passsword.
              </Form.Control.Feedback>
            </Form.Group>
            <Button variant="primary" value={'SUBMIT'} type="submit">
              Submit
            </Button>
          </Form>
          <A
            style={styles.passwordLink}
            href={LOGIN_ROUTES.passwordResetTrigger}>
            Forget your password?
          </A>
          <A href={LOGIN_ROUTES.signup}>Create an Account</A>
        </Col>
      </Row>
    </>
  )
}
